import { app } from '../../../../bootstrap/core';
import { progressPieComponent } from './progressPie.component';

app.component(progressPieComponent.name, progressPieComponent);



// WEBPACK FOOTER //
// ./src/app/components/status/components/progressPie/progressPie.js